export type PortalReviewLocation = {
  view: "client" | "job" | "sow" | "invoices";
  clientId: string;
  jobId: string;
  sowId: string;
};

type PortalLocationStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;

const PORTAL_LOCATION_KEY = "aquadraw:portal-review-location:v1";
const PORTAL_VIEWS = new Set<PortalReviewLocation["view"]>(["client", "job", "sow", "invoices"]);

export function loadPortalReviewLocation(storage: PortalLocationStorage): PortalReviewLocation | null {
  try {
    const raw = storage.getItem(PORTAL_LOCATION_KEY);
    if (!raw) return null;
    const value = JSON.parse(raw) as Partial<PortalReviewLocation>;
    if (!value.view || !PORTAL_VIEWS.has(value.view) || typeof value.clientId !== "string" || typeof value.jobId !== "string" || typeof value.sowId !== "string") {
      storage.removeItem(PORTAL_LOCATION_KEY);
      return null;
    }
    return { view: value.view, clientId: value.clientId, jobId: value.jobId, sowId: value.sowId };
  } catch {
    storage.removeItem(PORTAL_LOCATION_KEY);
    return null;
  }
}

export function savePortalReviewLocation(location: PortalReviewLocation, storage: PortalLocationStorage) {
  storage.setItem(PORTAL_LOCATION_KEY, JSON.stringify(location));
}
